import { useEffect, useMemo } from "react";
import { Grid, Icon, Popup, Select } from "semantic-ui-react";
import { defaultValues } from "../../../../../../app_constants";
import { SubnetPool } from "../../types/subnetPool";
import { HandleSelectChange } from "../../../../../../custom-hooks/form/types";

type AddressingTypeProps = {
  onChange: HandleSelectChange;
  pool: SubnetPool;
  addressingType?: string;
};

const AddressingType = ({
  onChange,
  pool,
  addressingType,
}: AddressingTypeProps) => {
  const availableOptions = useMemo(() => {
    if (!pool) return [];
    const options = defaultValues.subnet.ipv6_addressing_mode.map(
      (addressingMode, i) => ({
        key: i,
        value: addressingMode.value,
        text: addressingMode.text,
      }),
    );

    // SLAAC Addressing mode is only available for subnets with /64 prefix
    if (pool?.default_prefixlen !== "64") {
      return options.filter((mode) => mode.value !== "slaac");
    }

    return options;
  }, [pool]);

  useEffect(() => {
    if (availableOptions?.length && !addressingType) {
      onChange({} as React.FormEvent<HTMLElement>, {
        name: "addressingType",
        value: availableOptions[0].value,
      });
    }
  }, [availableOptions, onChange, addressingType]);

  if (!pool) return null;

  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-30"
      >
        <h5>
          Addressing type
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left-10"
              />
            }
          >
            Choose Addressing Mode.
            <br />
            Note: Only subnet pools with /64 prefix support SLAAC addressing
            mode.
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-30"
      >
        <Select
          icon="chevron circle down"
          className="select-box full"
          placeholder="Choose Addressing Mode"
          options={availableOptions}
          value={addressingType}
          name="addressingType"
          onChange={onChange}
        />
      </Grid.Column>
    </>
  );
};

export default AddressingType;
